import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ images, index, title, onClose, onIndex }) => {
  const open = index !== null && index !== undefined;
  const go = (d) => onIndex((index + d + images.length) % images.length);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % images.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + images.length) % images.length);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open, index, images.length, onClose, onIndex]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div data-testid="lightbox" data-lenis-prevent initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] bg-ink/95 backdrop-blur-xl flex flex-col" onClick={onClose}>
          <div className="flex items-center justify-between px-5 sm:px-8 py-4 text-white" onClick={(e) => e.stopPropagation()}>
            <p className="font-wide font-extrabold text-sm sm:text-base truncate pr-4">{title} <span className="font-mono text-xs text-slate-400 ml-2">{index + 1} / {images.length}</span></p>
            <button onClick={onClose} data-testid="lightbox-close" aria-label="Close" className="h-11 w-11 rounded-full border border-white/25 flex items-center justify-center hover:bg-white hover:text-ink transition-colors"><X className="h-5 w-5" /></button>
          </div>
          <div className="relative flex-1 flex items-center justify-center px-4 sm:px-20 pb-6" onClick={(e) => e.stopPropagation()}>
            <motion.img key={images[index]} src={images[index]} alt={`${title} photo ${index + 1}`} initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.35 }}
              className="max-h-[78vh] max-w-full object-contain" data-testid="lightbox-image" />
            {images.length > 1 && (
              <>
                <button onClick={() => go(-1)} data-testid="lightbox-prev" aria-label="Previous" className="absolute left-2 sm:left-6 h-12 w-12 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-brass hover:text-ink transition-colors"><ChevronLeft className="h-6 w-6" /></button>
                <button onClick={() => go(1)} data-testid="lightbox-next" aria-label="Next" className="absolute right-2 sm:right-6 h-12 w-12 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-brass hover:text-ink transition-colors"><ChevronRight className="h-6 w-6" /></button>
              </>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
